var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoavatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "820px",
    height: "820px",
    viewBox: "0 0 820 820",
    enableBackground: "new 0 0 820 820",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    fill: "#009BDF",
    width: 820,
    height: 820
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M593.849,512.152c-33.376-33.376-74.232-56.546-118.784-67.976C545.068,417.789,595,350.121,595,271 c0-102.01-82.99-185-185-185s-185,82.99-185,185c0,79.121,49.932,146.789,119.936,173.177c-44.552,11.43-85.408,34.6-118.783,67.976 C177.044,561.26,150,626.552,150,696h20c0-132.337,107.663-240,240-240s240,107.663,240,240h20 C670,626.552,642.956,561.26,593.849,512.152z M245,271c0-90.981,74.019-165,165-165s165,74.019,165,165s-74.019,165-165,165 S245,361.981,245,271z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoavatar);
export default __webpack_public_path__ + "static/media/noavatar.c2c6d8d8398782c17994b4ee48c9d270.svg";
export { ForwardRef as ReactComponent };